import React, { lazy, useState } from 'react';
import { READ_CUSTOMER, NEW_CUSTOMER, QUOTES, PROPOSAL, READ_POLICY, ENDORSE_POLICY, RENEW_POLICY, NEW_EXTERNAL_USER, NEW_INTERNAL_USER, ROLE_USER, MANAGE_INTERMEDIARY_USER, SEARCH_USER, READ_PAYMENT, CDACCOUNTS_PAYMENT, GENERATE_PAYSLIP, DOWNLOAD_PAYSLIP, CLAIMS, MIS_REPORTS, FINANCER_DETAILS, CREATE_PRODUCT_LEVEL_UW, MANAGE_LIMITS } from './permissions.js';
import { _ as _objectSpread2, a as _toConsumableArray, b as _objectWithoutProperties, c as _slicedToArray, d as _extends } from './_rollupPluginBabelHelpers-fb970440.js';
import { c as createCustVar, a as createCustMetaVar } from './state-a4d3dd58.js';
import { s as searchParamsVar } from './state-0f17d715.js';
import { u as updateCustVar, a as updateCustMetaVar } from './state-92ba719e.js';
import { makeVar, useQuery } from '@apollo/client';
import { intermediaryVar, updateAllIntermediaryFields } from './common/intermediary/state.js';
import { healthQuoteVar, healthPlansVar } from './quote/health/state.js';
import { buyHealthPolicyVar } from './proposal/health/state.js';
import { buyMotorPolicyVar } from './proposal/motor/state.js';
import { motorQuoteVar } from './quote/motor/state.js';
import { fireQuoteVar, fireQuoteAdditionalDetailsUploadDocsVar } from './quote/fire/state.js';
import { m as marineQuoteVar, h as housingSecQuoteVar } from './state-1fb1e261.js';
import { workCompQuoteVar, isAllIndiaVar as isAllIndiaVar$1 } from './quote/workmenscompensation/state.js';
import { b as buyIpaPolicyVar } from './state-cd3cac59.js';
import { b as buyWorkmenPolicyVar } from './state-74edd9f7.js';
import { b as buyMarinePolicyVar } from './state-f2888c41.js';
import { buyFirePolicyVar } from './proposal/fire/state.js';
import { shopSecQuoteVar } from './quote/shopsecure/state.js';
import { buyShopPolicyVar } from './proposal/shopsecure/state.js';
import { b as buyHousingPolicyVar } from './state-1686d318.js';
import { viewRenewPolicyVar } from './policy/renewal/health/state.js';
import { viewRenewMotorPolicyVar } from './policy/renewal/motor/state.js';
import { p as profileDataVar } from './ShortenString-21905b6b.js';
import { Route as Route$f, Redirect } from 'react-router-dom';
import { L as Loading } from './loading-c16d3bd3.js';
import { C as CHECK_AUTH_QUERY, G as GET_SELECTED_INTERMEDIARY } from './queries-3df8abcc.js';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import './ConfigProvider-9522944e.js';
import './CurrencyFormater-d288bc4f.js';
import './useMutationQuery-42b53d8d.js';
import './useFetchCacheQuery-88ef52f3.js';
import './useCoversAndPlans-e373c56e.js';

var SearchCustomer = /*#__PURE__*/lazy(function () {
  return import('./index-fb5b1c7d.js').then(function (n) { return n.i; });
});
var CustomerDetails = /*#__PURE__*/lazy(function () {
  return import('./index-e0ce055b.js').then(function (n) { return n.i; });
});
var CreateCustomer = /*#__PURE__*/lazy(function () {
  return import('./index-f20780c9.js').then(function (n) { return n.q; });
});
var EditCustomer = /*#__PURE__*/lazy(function () {
  return import('./index-5b38bc2c.js').then(function (n) { return n.l; });
});
var UploadDocuments$2 = /*#__PURE__*/lazy(function () {
  return import('./index-b4e34521.js');
});
var Route$e = [{
  secure: true,
  exact: true,
  permission: READ_CUSTOMER,
  path: '/customer/search',
  component: SearchCustomer
}, {
  secure: true,
  exact: true,
  permission: NEW_CUSTOMER,
  path: '/customer/create',
  component: CreateCustomer
}, {
  secure: true,
  exact: true,
  permission: READ_CUSTOMER,
  path: '/customer/:customerType/:customerNo',
  component: CustomerDetails
}, {
  secure: true,
  exact: true,
  // permission: READ_CUSTOMER,
  path: '/customer/:customerType/:customerNo/edit',
  component: EditCustomer
}, {
  secure: true,
  exact: true,
  // permission: UPLOAD,
  path: '/upload-documents/customer/:customerNo',
  component: UploadDocuments$2
}];

var SearchProduct = /*#__PURE__*/lazy(function () {
  return import('./index-e4c98166.js').then(function (n) { return n.i; });
});
var CaptureHealthDetails = /*#__PURE__*/lazy(function () {
  return import('./index-1718b50e.js').then(function (n) { return n.T; });
});
var NewHealthPolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-7a7e06c1.js').then(function (n) { return n.i; });
});
var NewPersonalAccidentPolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-8d0c62fd.js');
});
var NewFirePolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-9a8465ec.js').then(function (n) { return n.t; });
});
var NewShopPolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-4eb5f221.js').then(function (n) { return n.r; });
});
var NewHousingPolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-59a576f0.js');
});
var NewWorkmenCompensationPolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-b5aaa8cb.js');
});
var NewMarineVoyagePolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-6e08cb26.js');
});
var NewMotorPolicyIssuance = /*#__PURE__*/lazy(function () {
  return import('./index-8ac170ac.js').then(function (n) { return n.u; });
});
var SavedQuotes = /*#__PURE__*/lazy(function () {
  return import('./index-89f3507b.js').then(function (n) { return n.ag; });
});
var ViewQuoteDetails = /*#__PURE__*/lazy(function () {
  return import('./index-60914040.js').then(function (n) { return n.p; });
}); //SAMOD

var ModifyQuoteDetails = /*#__PURE__*/lazy(function () {
  return import('./index-1fa952cb.js');
}); //EAMOD

var SavedProposal = /*#__PURE__*/lazy(function () {
  return import('./index-19387fb0.js').then(function (n) { return n.x; });
});
var TermsAndConditions = /*#__PURE__*/lazy(function () {
  return import('./terms-and-conditions-e1c49b6d.js');
});
var ViewProposalDetails = /*#__PURE__*/lazy(function () {
  return import('./index-810c00e0.js').then(function (n) { return n.i; });
});
var CaptureTwoWheelerDetails = /*#__PURE__*/lazy(function () {
  return import('./index-2a36c11c.js').then(function (n) { return n.n; });
});
var CaptureFireDetails = /*#__PURE__*/lazy(function () {
  return import('./index-5a0fffa5.js').then(function (n) { return n.s; });
});
var CaptureMarineDetails = /*#__PURE__*/lazy(function () {
  return import('./index-c63a29df.js');
});
var CaptureIpaDetails = /*#__PURE__*/lazy(function () {
  return import('./index-70ceeeee.js');
});
var CaptureWorkmenCompensationDetails = /*#__PURE__*/lazy(function () {
  return import('./index-a9b27186.js').then(function (n) { return n.r; });
});
var CaptureShopSecureDetails = /*#__PURE__*/lazy(function () {
  return import('./index-ce75c842.js').then(function (n) { return n.a2; });
});
var CaptureHousingSocityDetails = /*#__PURE__*/lazy(function () {
  return import('./index-574c9572.js');
});
var Route$d = [{
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/select/product',
  component: SearchProduct
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Health/:lob_code/:product_name/:product_code',
  component: CaptureHealthDetails
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Motor/:lob_code/:product_name/:product_code',
  component: CaptureTwoWheelerDetails
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Fire/:lob_code/:product_name/:product_code',
  component: CaptureFireDetails
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Marine/:lob_code/:product_name/:product_code',
  component: CaptureMarineDetails
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Personal Accident/:lob_code/:product_name/:product_code',
  component: CaptureIpaDetails
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Miscellaneous/29/:product_name/2914',
  props: {
    product_code: '2914',
    lob_code: '29'
  },
  component: CaptureHousingSocityDetails
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/health/buy/:lob_code/:product_name/:product_code/:plan_code/:plan_name',
  component: NewHealthPolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Miscellaneous/29/:product_name/2923',
  props: {
    product_code: '2923',
    lob_code: '29'
  },
  component: CaptureShopSecureDetails
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Miscellaneous/:lob_code/:product_name/:product_code',
  component: CaptureWorkmenCompensationDetails
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/personalAccident/:lob_code/:product_name/:product_code',
  component: NewPersonalAccidentPolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/motor/buy/:lob_code/:product_name/:product_code/:product_type',
  component: NewMotorPolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/miscellaneous/buy/29/:product_name/2914',
  component: NewHousingPolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/miscellaneous/buy/29/:product_name/2923',
  component: NewShopPolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/Miscellaneous/buy/:lob_code/:product_name/:product_code',
  component: NewWorkmenCompensationPolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/Fire/buy/:lob_code/:product_name/:product_code',
  component: NewFirePolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/Marine/buy/:lob_code/:product_name/:product_code',
  component: NewMarineVoyagePolicyIssuance
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/saved',
  component: SavedQuotes
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/saved/smart',
  component: function component() {
    return /*#__PURE__*/React.createElement(SavedQuotes, {
      smart: true
    });
  }
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/saved/smarter',
  component: function component() {
    return /*#__PURE__*/React.createElement(SavedQuotes, {
      smart: true,
      voice: true
    });
  }
}, {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/saved/:lob_code/:lob_name/:product_code/:product_name/:quote_number',
  component: ViewQuoteDetails
}, //SAMOD
{
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/saved/:lob_code/:lob_name/:product_code/:product_name/:quote_number/:proposal_number/:modify',
  component: ModifyQuoteDetails
}, //EAMOD
{
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/proposal/search',
  component: SavedProposal
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/:product_code/termsAndConditions',
  component: TermsAndConditions
}, {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/proposal/saved/:customerID/:lob_code/:lob_name/:product_code/:product_name/:proposal_number',
  component: ViewProposalDetails
}];

var LandingPage = /*#__PURE__*/lazy(function () {
  return import('./landing-4b8c112d.js');
});
var LoginPage = /*#__PURE__*/lazy(function () {
  return import('./login-b974dd4e.js');
});
var LogoutPage = /*#__PURE__*/lazy(function () {
  return import('./logout-a45af11c.js');
});
var ErrorPage = /*#__PURE__*/lazy(function () {
  return import('./error-bad58974.js');
});
var NoPermissionPage = /*#__PURE__*/lazy(function () {
  return import('./NoPermission-7e4098bd.js');
});
var Route$c = [{
  secure: true,
  exact: true,
  path: '/landing',
  component: LandingPage
}, {
  exact: true,
  path: '/login',
  component: LoginPage
}, {
  exact: true,
  path: '/logout',
  component: LogoutPage
}, {
  exact: true,
  path: '/error',
  component: ErrorPage
}, {
  exact: true,
  path: '/nopermission',
  component: NoPermissionPage
}, {
  path: '/',
  component: LoginPage
}];

var SearchPolicy = /*#__PURE__*/lazy(function () {
  return import('./index-75f0211d.js').then(function (n) { return n.m; });
});
var SearchEndorsePolicy = /*#__PURE__*/lazy(function () {
  return import('./index-353ae3ae.js');
});
var ViewPolicy = /*#__PURE__*/lazy(function () {
  return import('./index-d277e694.js').then(function (n) { return n.i; });
});
var SearchPolicyRenewal = /*#__PURE__*/lazy(function () {
  return import('./index-725f8359.js').then(function (n) { return n.i; });
});
var ViewRenewPolicy = /*#__PURE__*/lazy(function () {
  return import('./index-5ba41c63.js');
});
var UploadDocuments$1 = /*#__PURE__*/lazy(function () {
  return import('./index-b4e34521.js');
});
var EndorsePolicy = /*#__PURE__*/lazy(function () {
  return import('./index-8dd9feb9.js');
});
var Route$b = [{
  secure: true,
  exact: true,
  permission: READ_POLICY,
  path: '/policy/search',
  component: SearchPolicy
}, {
  secure: true,
  exact: true,
  permission: ENDORSE_POLICY,
  path: '/policy/endorse/search',
  component: SearchEndorsePolicy
}, {
  secure: true,
  exact: true,
  permission: READ_POLICY,
  path: '/policy/view/:lob_code/:lob_name/:customer_id/:proposal_no/:policy_no',
  component: ViewPolicy
}, {
  secure: true,
  exact: true,
  permission: RENEW_POLICY,
  path: '/policy/renew/search',
  component: SearchPolicyRenewal
}, {
  secure: true,
  exact: true,
  permission: RENEW_POLICY,
  path: '/policy/renew/:customerID/:product_code/:product_name/:proposal_number/:renewal_mode/:rcStatus/:modify',
  component: ViewRenewPolicy
}, {
  secure: true,
  exact: true,
  // permission: UPLOAD,
  path: '/upload-documents/policy/:policy_no',
  component: UploadDocuments$1
}, {
  secure: true,
  exact: true,
  path: '/policy/endorse/:customerID/:product_code/:product_name/:proposal_number',
  component: EndorsePolicy
}];

var CreateExternalUser = /*#__PURE__*/lazy(function () {
  return import('./index-e788858f.js');
});
var ManageRoles = /*#__PURE__*/lazy(function () {
  return import('./index-6728fb49.js');
});
var CreateRole = /*#__PURE__*/lazy(function () {
  return import('./index-a3593c61.js');
});
var CreateInternalUser = /*#__PURE__*/lazy(function () {
  return import('./index-ab0fca59.js');
});
var ChangePassword = /*#__PURE__*/lazy(function () {
  return import('./index-a3984222.js');
});
var UserProfile = /*#__PURE__*/lazy(function () {
  return import('./index-3757284d.js');
});
var RegisterPassCode = /*#__PURE__*/lazy(function () {
  return import('./index-70f694d8.js');
});
var ResetPassword = /*#__PURE__*/lazy(function () {
  return import('./index-f30ce1f7.js');
});
var SearchUser = /*#__PURE__*/lazy(function () {
  return import('./index-c5550e84.js');
});
var UpdateUser = /*#__PURE__*/lazy(function () {
  return import('./index-edcd5d8f.js');
});
var ManageIntermediary = /*#__PURE__*/lazy(function () {
  return import('./index-3d7289c5.js');
});
var Route$a = [{
  secure: true,
  exact: true,
  permission: NEW_EXTERNAL_USER,
  path: '/security/user/external/new',
  component: CreateExternalUser
}, {
  secure: true,
  exact: true,
  permission: NEW_INTERNAL_USER,
  path: '/security/user/internal/new',
  component: CreateInternalUser
}, {
  secure: true,
  exact: true,
  permission: ROLE_USER,
  path: '/security/roles',
  component: ManageRoles
}, {
  secure: true,
  exact: true,
  permission: ROLE_USER,
  path: '/security/role/new',
  component: CreateRole
}, {
  secure: true,
  exact: true,
  path: '/security/password/change',
  component: ChangePassword
}, {
  secure: true,
  exact: true,
  path: '/security/password/forcechange',
  component: function component() {
    return /*#__PURE__*/React.createElement(ChangePassword, {
      forceChangePassword: true
    });
  }
}, {
  secure: true,
  exact: true,
  path: '/security/profile',
  component: UserProfile
}, {
  secure: true,
  exact: true,
  path: '/security/passcode/enable',
  component: RegisterPassCode
}, {
  secure: false,
  exact: true,
  path: '/security/password/reset',
  component: ResetPassword
}, {
  secure: true,
  exact: true,
  permission: MANAGE_INTERMEDIARY_USER,
  path: '/security/users/search/intermediary',
  component: ManageIntermediary
}, {
  secure: true,
  exact: true,
  permission: SEARCH_USER,
  path: '/security/users/search',
  component: SearchUser
}, {
  secure: true,
  exact: true,
  permission: MANAGE_INTERMEDIARY_USER ,
  path: '/security/users/detail',
  component: UpdateUser
}];

var SearchPayments = /*#__PURE__*/lazy(function () {
  return import('./index-555156b3.js').then(function (n) { return n.i; });
});
var ManageCdAccount = /*#__PURE__*/lazy(function () {
  return import('./index-c16685ad.js');
});
var RefillAccount = /*#__PURE__*/lazy(function () {
  return import('./index-57931355.js');
});
var GeneratePayInSlip = /*#__PURE__*/lazy(function () {
  return import('./index-536403c9.js');
});
var DownloadPaySlip = /*#__PURE__*/lazy(function () {
  return import('./index-260d662c.js');
});
var CDTransactionHistory = /*#__PURE__*/lazy(function () {
  return import('./index-613e3375.js');
});
var Route$9 = [{
  secure: true,
  exact: true,
  permission: READ_PAYMENT,
  path: '/payments/search',
  component: SearchPayments
}, {
  secure: true,
  exact: true,
  permission: CDACCOUNTS_PAYMENT,
  path: '/payments/managecdaccount',
  component: ManageCdAccount
}, {
  secure: true,
  exact: true,
  permission: READ_PAYMENT,
  path: '/payments/refillaccount/:account_ID/:imd_Code',
  component: RefillAccount
}, {
  secure: true,
  exact: true,
  permission: GENERATE_PAYSLIP,
  path: '/payments/generate-payslip',
  component: GeneratePayInSlip
}, {
  secure: true,
  exact: true,
  permission: DOWNLOAD_PAYSLIP,
  path: '/payments/download-deposition-slip',
  component: DownloadPaySlip
}, {
  secure: true,
  exact: true,
  permission: READ_PAYMENT,
  path: '/payments/cd-transaction-history',
  component: CDTransactionHistory
}];

var Home = /*#__PURE__*/lazy(function () {
  return import('./index-51dc6d73.js').then(function (n) { return n.w; });
});
var Route$8 = [{
  secure: true,
  exact: true,
  path: '/home',
  component: Home
}];

var SearchClaims = /*#__PURE__*/lazy(function () {
  return import('./index-583dfe2b.js').then(function (n) { return n.i; });
});
var ViewMotorClaims = /*#__PURE__*/lazy(function () {
  return import('./index-5f329bcb.js').then(function (n) { return n.i; });
});
var HealthClaims = /*#__PURE__*/lazy(function () {
  return import('./index-f13094c9.js');
});
var MotorEscalation = /*#__PURE__*/lazy(function () {
  return import('./Motor-3b93697c.js');
}); //import HealthEscalation from './EscalationMatrix/health';

var HealthEscalation = /*#__PURE__*/lazy(function () {
  return import('./HealthEscalationMatrix-f9b33b18.js');
});
var Route$7 = [{
  secure: true,
  exact: true,
  permission: CLAIMS,
  path: '/claims/Motor/track',
  component: SearchClaims
}, {
  secure: true,
  exact: true,
  permission: CLAIMS,
  path: '/claims/Motor/view/:claimNumber',
  component: ViewMotorClaims
}, {
  secure: true,
  exact: true,
  permission: CLAIMS,
  path: '/claims/Health/track',
  component: HealthClaims
}, {
  secure: true,
  exact: true,
  permission: CLAIMS,
  path: '/claims/EscalationMatrix/health',
  component: HealthEscalation
}, {
  secure: true,
  exact: true,
  permission: CLAIMS,
  path: '/claims/EscalationMatrix/motor',
  component: MotorEscalation
}];

var RaiseReportRequest = /*#__PURE__*/lazy(function () {
  return import('./index-1f7b15ae.js');
});
var Route$6 = [{
  secure: true,
  exact: true,
  permission: MIS_REPORTS,
  path: '/reports/raise-and-track-report',
  component: RaiseReportRequest
}];

var UploadDocuments = /*#__PURE__*/lazy(function () {
  return import('./index-b4e34521.js');
});
var Route$5 = [{
  secure: true,
  exact: true,
  // permission: MIS_REPORTS,
  path: '/upload-documents',
  component: UploadDocuments
}];

var FinancerDetails = /*#__PURE__*/lazy(function () {
  return import('./index-9e12fe01.js');
});
var Route$4 = [{
  secure: true,
  exact: true,
  permission: FINANCER_DETAILS,
  path: '/financerdetails',
  component: FinancerDetails
}];

var VehicleInspection = /*#__PURE__*/lazy(function () {
  return import('./index-7dda261e.js');
});
var Route$3 = [{
  secure: true,
  exact: true,
  permission: READ_POLICY,
  path: '/vehicle-inspection',
  component: VehicleInspection
}];

var PincodeExclusionMaster = /*#__PURE__*/lazy(function () {
  return import('./index-ebe914c3.js');
});
var DefaultMaster = /*#__PURE__*/lazy(function () {
  return import('./index-88393a81.js');
});
var Route$2 = [{
  secure: true,
  exact: true,
  permission: CREATE_PRODUCT_LEVEL_UW,
  path: '/productleveluw/pincode-exclusion',
  component: PincodeExclusionMaster
}, {
  secure: true,
  exact: true,
  permission: CREATE_PRODUCT_LEVEL_UW,
  path: '/productleveluw/default-master',
  component: DefaultMaster
}];

var AgentLevelUWLimits = /*#__PURE__*/lazy(function () {
  return import('./index-c5ef1646.js');
});
var Route$1 = [{
  secure: true,
  exact: true,
  path: '/agent-level-UW-limits',
  permission: MANAGE_LIMITS,
  component: AgentLevelUWLimits
}];

var MySalesDashboard = /*#__PURE__*/lazy(function () {
  return import('./index-2d0b2806.js');
});
var Route = [{
  secure: true,
  exact: true,
  path: '/sales-dashboard',
  component: MySalesDashboard
}];

function mergeCache() {
  for (var _len = arguments.length, caches = new Array(_len), _key = 0; _key < _len; _key++) {
    caches[_key] = arguments[_key];
  }

  return caches.reduce(function (b, a) {
    var keys_b = Object.keys(b);
    var keys_a = Object.keys(a);
    keys_b.forEach(function (each_key_b) {
      if (keys_a.find(function (each_key_a) {
        return each_key_a === each_key_b;
      })) {
        throw Error("error: cache keys must be unique [" + each_key_b + "]");
      }
    });
    return _objectSpread2(_objectSpread2({}, b), a);
  });
}
function mergeRoutes() {
  for (var _len2 = arguments.length, routes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    routes[_key2] = arguments[_key2];
  }

  return routes.reduce(function (b, a) {
    var keys_b = b.map(function (each_b) {
      return each_b.path;
    });
    var keys_a = a.map(function (each_a) {
      return each_a.path;
    });
    keys_b.forEach(function (each_key_b) {
      if (keys_a.find(function (each_key_a) {
        return each_key_a === each_key_b;
      })) {
        throw Error("error: route paths must be unique [" + each_key_b + "]");
      }
    });
    return [].concat(_toConsumableArray(b), _toConsumableArray(a));
  });
}

var cache$y = {
  createCust: {
    read: function read() {
      return createCustVar();
    }
  },
  createCustMeta: {
    read: function read() {
      return createCustMetaVar();
    }
  }
};

var cache$x = {
  searchParams: {
    read: function read() {
      return _objectSpread2(_objectSpread2({}, searchParamsVar()), {}, {
        __typename: 'search_params_var'
      });
    }
  }
};

var cache$w = {
  updateCust: {
    read: function read() {
      return updateCustVar();
    }
  },
  updateCustMeta: {
    read: function read() {
      return updateCustMetaVar();
    }
  }
};

var cache$v = mergeCache(cache$y, cache$x, cache$w);

var init_state$2 = {
  intermediaryName: "MTPL",
  intermediaryCode: "C1234567890",
  branchOffice: "Mumbai (Kalina)",
  fieldUser: "John Doe",
  polInsOffice: "Mumbai (Kalina)",
  cdAccNo: "C9876543",
  cdAccBal: 48876.92
};
var createIntermediaryVar = makeVar(init_state$2);
var initCreateIntermediaryState = function initCreateIntermediaryState() {
  createIntermediaryVar(init_state$2);
};
var updateIntermediary = function updateIntermediary(data) {
  return createIntermediaryVar(data);
};

var cache$u = {
  quoteIntermediary: {
    read: function read() {
      return createIntermediaryVar();
    }
  }
};

var cache$t = {
  selectedIntermediary: {
    read: function read() {
      return intermediaryVar();
    }
  }
};

var cache$s = {
  healthQuote: {
    read: function read() {
      return healthQuoteVar();
    }
  },
  healthPlans: {
    read: function read() {
      return healthPlansVar();
    }
  }
};

var cache$r = {
  buyHealthPolicy: {
    read: function read() {
      return buyHealthPolicyVar();
    }
  }
};

var cache$q = {
  buyMotorPolicy: {
    read: function read() {
      return buyMotorPolicyVar();
    }
  }
};

var cache$p = {
  motorQuote: {
    read: function read() {
      return motorQuoteVar();
    }
  }
};

var cache$o = {
  fireQuote: {
    read: function read() {
      return fireQuoteVar();
    }
  },
  fireQuoteUploadDocs: {
    read: function read() {
      return fireQuoteAdditionalDetailsUploadDocsVar();
    }
  }
};

var cache$n = {
  marineQuote: {
    read: function read() {
      return marineQuoteVar();
    }
  }
};

var _excluded$3 = ["premiumData", "tabDetails"];
var init_state_quote = {
  get_covers: false,
  quoteNumber: '',
  currentTab: 0,
  proposalNumber: '',
  quoteCreationDate: '',
  quoteStatus: '',
  isSaveQuoteEnabled: false,
  premiumData: {
    discount: [],
    loading: [],
    netPremium: '',
    stampDuty: '',
    gst: '',
    totalPremium: ''
  },
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  tabDetails: {
    planTabDetails: {
      businessType: {
        code: '',
        value: ''
      },
      memberType: {
        code: '',
        value: ''
      },
      location: {
        pincode: '',
        state: ''
      },
      occupationType: {
        code: '',
        value: ''
      },
      otherOccupation: '',
      riskCategory: '',
      dob: '',
      employeeType: '',
      organizationType: '',
      existingEmployeeId: '',
      plan: [],
      selectedPlan: '',
      selectedPlanCode: '',
      selectedSubPlan: '',
      selectedSubPlanCode: '',
      selectedTenure: '',
      selectedTenureCode: ''
    },
    coverData: {
      addOnCovers: [],
      rawRiskData: []
    }
  },
  customer: {},
  customerMeta: {}
};
var ipaQuoteVar = makeVar(init_state_quote);
var initIpaQuoteState = function initIpaQuoteState() {
  return ipaQuoteVar(init_state_quote);
};
var updateCustomerInformation = function updateCustomerInformation(customerInformation) {
  return ipaQuoteVar(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
    customer: customerInformation !== null && customerInformation !== void 0 && customerInformation.customer ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customer : {},
    customerMeta: customerInformation !== null && customerInformation !== void 0 && customerInformation.customerMeta ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customerMeta : {}
  }));
};
var updateIpaQuote = function updateIpaQuote(data) {
  var premiumData = data.premiumData,
      tabDetails = data.tabDetails,
      restData = _objectWithoutProperties(data, _excluded$3);

  if (tabDetails) {
    var planTabDetails = tabDetails.planTabDetails,
        coverData = tabDetails.coverData;
  }

  if (premiumData) {
    if (planTabDetails && coverData) {
      var _ipaQuoteVar;

      ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
        premiumData: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar = ipaQuoteVar()) === null || _ipaQuoteVar === void 0 ? void 0 : _ipaQuoteVar.premiumData), premiumData),
        tabDetails: {
          planTabDetails: planTabDetails,
          coverData: coverData
        }
      }, restData), {}, {
        get_covers: true
      }));
    } else if (!planTabDetails && coverData) {
      var _ipaQuoteVar2, _ipaQuoteVar3;

      ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
        premiumData: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar2 = ipaQuoteVar()) === null || _ipaQuoteVar2 === void 0 ? void 0 : _ipaQuoteVar2.premiumData), premiumData),
        tabDetails: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar3 = ipaQuoteVar()) === null || _ipaQuoteVar3 === void 0 ? void 0 : _ipaQuoteVar3.tabDetails), {}, {
          coverData: coverData
        })
      }, restData), {}, {
        get_covers: true
      }));
    } else if (planTabDetails && !coverData) {
      var _ipaQuoteVar4, _ipaQuoteVar5;

      ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
        premiumData: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar4 = ipaQuoteVar()) === null || _ipaQuoteVar4 === void 0 ? void 0 : _ipaQuoteVar4.premiumData), premiumData),
        tabDetails: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar5 = ipaQuoteVar()) === null || _ipaQuoteVar5 === void 0 ? void 0 : _ipaQuoteVar5.tabDetails), {}, {
          planTabDetails: planTabDetails
        })
      }, restData), {}, {
        get_covers: true
      }));
    } else {
      var _ipaQuoteVar6;

      ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
        premiumData: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar6 = ipaQuoteVar()) === null || _ipaQuoteVar6 === void 0 ? void 0 : _ipaQuoteVar6.premiumData), premiumData)
      }, restData), {}, {
        get_covers: true
      }));
    }
  } else if (tabDetails && planTabDetails && coverData) {
    var _ipaQuoteVar7, _ipaQuoteVar7$tabDeta, _ipaQuoteVar8, _ipaQuoteVar8$tabDeta;

    ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
      tabDetails: {
        planTabDetails: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar7 = ipaQuoteVar()) === null || _ipaQuoteVar7 === void 0 ? void 0 : (_ipaQuoteVar7$tabDeta = _ipaQuoteVar7.tabDetails) === null || _ipaQuoteVar7$tabDeta === void 0 ? void 0 : _ipaQuoteVar7$tabDeta.planTabDetails), planTabDetails),
        coverData: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar8 = ipaQuoteVar()) === null || _ipaQuoteVar8 === void 0 ? void 0 : (_ipaQuoteVar8$tabDeta = _ipaQuoteVar8.tabDetails) === null || _ipaQuoteVar8$tabDeta === void 0 ? void 0 : _ipaQuoteVar8$tabDeta.coverData), coverData)
      }
    }, restData), {}, {
      get_covers: true
    }));
  } else if (tabDetails && planTabDetails && !coverData) {
    var _ipaQuoteVar9, _ipaQuoteVar10, _ipaQuoteVar10$tabDet;

    ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
      tabDetails: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar9 = ipaQuoteVar()) === null || _ipaQuoteVar9 === void 0 ? void 0 : _ipaQuoteVar9.tabDetails), {}, {
        planTabDetails: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar10 = ipaQuoteVar()) === null || _ipaQuoteVar10 === void 0 ? void 0 : (_ipaQuoteVar10$tabDet = _ipaQuoteVar10.tabDetails) === null || _ipaQuoteVar10$tabDet === void 0 ? void 0 : _ipaQuoteVar10$tabDet.planTabDetails), planTabDetails)
      })
    }, restData), {}, {
      get_covers: true
    }));
  } else if (tabDetails && !planTabDetails && coverData) {
    var _ipaQuoteVar11, _ipaQuoteVar12, _ipaQuoteVar12$tabDet;

    ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
      tabDetails: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar11 = ipaQuoteVar()) === null || _ipaQuoteVar11 === void 0 ? void 0 : _ipaQuoteVar11.tabDetails), {}, {
        coverData: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar12 = ipaQuoteVar()) === null || _ipaQuoteVar12 === void 0 ? void 0 : (_ipaQuoteVar12$tabDet = _ipaQuoteVar12.tabDetails) === null || _ipaQuoteVar12$tabDet === void 0 ? void 0 : _ipaQuoteVar12$tabDet.coverData), coverData)
      })
    }, restData), {}, {
      get_covers: true
    }));
  } else {
    ipaQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), restData), {}, {
      get_covers: true
    }));
  }
};
var updateQuotationDetails = function updateQuotationDetails(quoteNumber, quoteStatus, quoteCreationDate, isSaveQuoteEnabled, addOnCovers) {
  var _ipaQuoteVar13;

  ipaQuoteVar(_objectSpread2(_objectSpread2({}, ipaQuoteVar()), {}, {
    quoteNumber: quoteNumber,
    quoteStatus: quoteStatus,
    quoteCreationDate: quoteCreationDate,
    isSaveQuoteEnabled: isSaveQuoteEnabled,
    tabDetails: _objectSpread2(_objectSpread2({}, (_ipaQuoteVar13 = ipaQuoteVar()) === null || _ipaQuoteVar13 === void 0 ? void 0 : _ipaQuoteVar13.tabDetails), {}, {
      coverData: {
        addOnCovers: addOnCovers,
        rawRiskData: []
      }
    })
  }));
};

var cache$m = {
  ipaQuote: {
    read: function read() {
      return ipaQuoteVar();
    }
  }
};

var cache$l = {
  workmenCompensationQuote: {
    read: function read() {
      return workCompQuoteVar();
    }
  },
  isAllIndiaBasisVar: {
    read: function read() {
      return isAllIndiaVar$1();
    }
  }
};

var cache$k = {
  buyIpaPolicy: {
    read: function read() {
      return buyIpaPolicyVar();
    }
  }
};

var cache$j = {
  buyWorkmenPolicy: {
    read: function read() {
      return buyWorkmenPolicyVar();
    }
  },
  isAllIndiaBasVar: {
    read: function read() {
      return isAllIndiaVar();
    }
  }
};

var cache$i = {
  buyMarinePolicy: {
    read: function read() {
      return buyMarinePolicyVar();
    }
  }
};

var cache$h = {
  buyFirePolicy: {
    read: function read() {
      return buyFirePolicyVar();
    }
  }
};

var cache$g = {
  shopsecureQuote: {
    read: function read() {
      return shopSecQuoteVar();
    }
  }
};

var cache$f = {
  buyShopPolicy: {
    read: function read() {
      return buyShopPolicyVar();
    }
  }
};

var cache$e = {
  housingsocityQuote: {
    read: function read() {
      return housingSecQuoteVar();
    }
  }
};

var cache$d = {
  buyHousingPolicy: {
    read: function read() {
      return buyHousingPolicyVar();
    }
  }
};

var cache$c = mergeCache(cache$u, cache$t, cache$s, cache$o, cache$m, cache$l, cache$g, //CNG 2914
cache$e, cache$p, cache$r, cache$q, cache$k, cache$j, cache$i, cache$h, cache$n, cache$f, //CNG 2914
cache$d);

var cache$b = {
  viewRenewPolicy: {
    read: function read() {
      return viewRenewPolicyVar();
    }
  }
};

var cache$a = {
  viewRenewMotorPolicy: {
    read: function read() {
      return viewRenewMotorPolicyVar();
    }
  }
};

var cache$9 = mergeCache(cache$b, cache$a);

var _excluded$2 = ["proposerDetails", "proposerDetailsMeta"],
    _excluded2$1 = ["proposerDetails", "proposerDetailsMeta"];
var init_state$1 = {
  endorsementEffectiveDate: '',
  endorsementEffectiveTime: '',
  endorsementType: '',
  endorsementTypeValue: '',
  endorsementCategory: '',
  nilEndorsement: false,
  nonNilEndorsement: false,
  businessType: '',
  customerFetchRequiredOnLoad: false,
  isQuoteSaved: false,
  quoteData: null,
  planData: null,
  prevPlanData: null,
  prevPlanName: '',
  prevTotalPremium: '',
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  isProposalEndorsed: false,
  proposalStatus: '',
  proposalPaymentType: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  planName: '',
  planCode: '',
  totalPremium: '',
  premiumLoading: false,
  planLoading: false,
  isProposalReadyForEndorsement: true,
  applicationNo: '',
  isPedDetailsSelected: 'No',
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: '',
    intermediaryName: '',
    branchOfficeName: ''
  },
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    otherOccupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: true,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: ''
  },
  sameNomineeForAllInsured: false,
  isHealthDeclarationSelected: '',
  initialHealthDeclarationSelected: '',
  insuredDetails: [],
  prevInsuranceDetails: [],
  nomineeDetails: [],
  medicalQuestionaire: [],
  underwritingAssignmentData: [],
  pedDetails: [],
  renewalMandateDetails: {
    renewalPaymentMandateTakenInNameOf: '',
    renewalPaymentMandate: false,
    termForMandateOpted: '',
    accountNumber: '',
    destinationBankName: '',
    destinationIfscCode: '',
    destinationMicrCode: '',
    branchName: '',
    mandateAmount: '',
    typeOfDebit: '',
    finalCollectionDate: '',
    destinationBankAccountType: ''
  },
  policyNumber: '',
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    //CN15
    receiptPayment: {
      receiptId: '' // isReceiptIdVerified: null,

    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var init_state_read_only$1 = {
  businessType: '',
  customerFetchRequiredOnLoad: false,
  isQuoteSaved: false,
  quoteData: null,
  planData: null,
  prevPlanData: null,
  prevPlanName: '',
  prevTotalPremium: '',
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  isProposalEndorsed: false,
  proposalStatus: '',
  proposalPaymentType: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  applicationNo: '',
  planName: '',
  planCode: '',
  totalPremium: '',
  premiumLoading: false,
  planLoading: false,
  isProposalReadyForEndorsement: true,
  isPedDetailsSelected: 'No',
  pedDetails: [],
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: '',
    intermediaryName: '',
    branchOfficeName: ''
  },
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    otherOccupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: true,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: ''
  },
  sameNomineeForAllInsured: false,
  isHealthDeclarationSelected: '',
  initialHealthDeclarationSelected: '',
  insuredDetails: [],
  prevInsuranceDetails: [],
  nomineeDetails: [],
  medicalQuestionaire: [],
  underwritingAssignmentData: [],
  renewalMandateDetails: {
    renewalPaymentMandate: false,
    renewalPaymentMandateTakenInNameOf: '',
    termForMandateOpted: '',
    accountNumber: '',
    destinationBankName: '',
    destinationIfscCode: '',
    destinationMicrCode: '',
    branchName: '',
    mandateAmount: '',
    typeOfDebit: '',
    finalCollectionDate: '',
    destinationBankAccountType: ''
  },
  policyNumber: '',
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    //CN15
    receiptPayment: {
      receiptId: '' // isReceiptIdVerified: null,

    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var init_state_upload_docs = {
  documentDetails: [{
    documentDescription: '',
    documentName: '',
    documentNameValue: '',
    documentFileName: '',
    documentExtension: '',
    documentSize: null,
    dragging: false,
    dragCounter: 0,
    documentBase64String: ''
  }]
};
var endorseHealthPolicyVar = makeVar(init_state$1);
var endorseHealthPolicyReadOnlyVar = makeVar(init_state_read_only$1);
var uploadDocsPolicyVar$1 = makeVar(init_state_upload_docs);
var initEndorseHealthPolicyVar = function initEndorseHealthPolicyVar() {
  endorseHealthPolicyVar(init_state$1);
  endorseHealthPolicyReadOnlyVar(init_state_read_only$1);
  uploadDocsPolicyVar$1(init_state_upload_docs);
}; // export const resetProposerDetails = (data) => {
//   let initObj = {},
//     initMetaObj = {};
//   Object.keys(viewRenewPolicyVar().proposerDetails).forEach((v) => {
//     if (data?.proposerDetails[v]) {
//       initObj[v] = data.proposerDetails[v];
//     } else {
//       if (v === 'permCommAddressYN') {
//         initObj[v] = false;
//       } else {
//         initObj[v] = '';
//       }
//     }
//   });
//   Object.keys(viewRenewPolicyVar().proposerDetailsMeta).forEach(
//     (v) => {
//       if (data?.proposerDetailsMeta[v]) {
//         initMetaObj[v] = data.proposerDetailsMeta[v];
//       } else {
//         initMetaObj[v] = '';
//       }
//     },
//   );
//   viewRenewPolicyVar({
//     ...viewRenewPolicyVar(),
//     proposerDetails: initObj,
//     proposerDetailsMeta: initMetaObj,
//   });
// };
// export const updateHealthDeclaration = (data) =>
//   viewRenewPolicyVar({
//     ...viewRenewPolicyVar(),
//     ...data,
//   });

var updatePlanWithPrevPlan = function updatePlanWithPrevPlan(isTotalPremiumRetainRequired) {
  var _endorseHealthPolicyV, _endorseHealthPolicyV2, _endorseHealthPolicyV3, _endorseHealthPolicyV4;

  endorseHealthPolicyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar()), {}, {
    planData: _objectSpread2(_objectSpread2({}, (_endorseHealthPolicyV = endorseHealthPolicyVar()) === null || _endorseHealthPolicyV === void 0 ? void 0 : _endorseHealthPolicyV.planData), (_endorseHealthPolicyV2 = endorseHealthPolicyVar()) === null || _endorseHealthPolicyV2 === void 0 ? void 0 : _endorseHealthPolicyV2.prevPlanData),
    planName: (_endorseHealthPolicyV3 = endorseHealthPolicyVar()) === null || _endorseHealthPolicyV3 === void 0 ? void 0 : _endorseHealthPolicyV3.prevPlanName,
    totalPremium: isTotalPremiumRetainRequired ? (_endorseHealthPolicyV4 = endorseHealthPolicyVar()) === null || _endorseHealthPolicyV4 === void 0 ? void 0 : _endorseHealthPolicyV4.prevTotalPremium : '',
    isProposalReadyForEndorsement: true
  }));
};
var updatePrevPlanWithPlan = function updatePrevPlanWithPlan() {
  var _endorseHealthPolicyV5, _endorseHealthPolicyV6;

  endorseHealthPolicyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar()), {}, {
    prevPlanData: _objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().prevPlanData), endorseHealthPolicyVar().planData),
    prevPlanName: (_endorseHealthPolicyV5 = endorseHealthPolicyVar()) === null || _endorseHealthPolicyV5 === void 0 ? void 0 : _endorseHealthPolicyV5.planName,
    prevTotalPremium: (_endorseHealthPolicyV6 = endorseHealthPolicyVar()) === null || _endorseHealthPolicyV6 === void 0 ? void 0 : _endorseHealthPolicyV6.totalPremium
  }));
};
var updateEndorsementPolicyVar$1 = function updateEndorsementPolicyVar(data) {
  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded$2);

  if (proposerDetails && proposerDetailsMeta) {
    endorseHealthPolicyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    endorseHealthPolicyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    endorseHealthPolicyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    endorseHealthPolicyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar()), rest));
  }
};
var updateEndorsementPolicyReadOnlyVar$1 = function updateEndorsementPolicyReadOnlyVar(data) {
  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded2$1);

  if (proposerDetails && proposerDetailsMeta) {
    endorseHealthPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    endorseHealthPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    endorseHealthPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    endorseHealthPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar()), rest));
  }
};
var updatePlanPremium = function updatePlanPremium(planName, premium) {
  endorseHealthPolicyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar()), {}, {
    planData: _objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().planData), {}, {
      plans: [].concat(_toConsumableArray(endorseHealthPolicyVar().planData.plans.filter(function (plan) {
        return plan.name.toLowerCase() !== planName.toLowerCase();
      })), [_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().planData.plans.find(function (plan) {
        return plan.name.toLowerCase() === planName.toLowerCase();
      })), {}, {
        premium: premium
      })])
    }),
    prevPlanData: _objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().prevPlanData), {}, {
      plans: [].concat(_toConsumableArray(endorseHealthPolicyVar().prevPlanData.plans.filter(function (plan) {
        return plan.name.toLowerCase() !== planName.toLowerCase();
      })), [_objectSpread2(_objectSpread2({}, endorseHealthPolicyVar().prevPlanData.plans.find(function (plan) {
        return plan.name.toLowerCase() === planName.toLowerCase();
      })), {}, {
        premium: premium
      })])
    })
  }));
};
var updatePlanPremiumReadOnlyVar = function updatePlanPremiumReadOnlyVar(planName, premium) {
  endorseHealthPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar()), {}, {
    planData: _objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().planData), {}, {
      plans: [].concat(_toConsumableArray(endorseHealthPolicyReadOnlyVar().planData.plans.filter(function (plan) {
        return plan.name.toLowerCase() !== planName.toLowerCase();
      })), [_objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().planData.plans.find(function (plan) {
        return plan.name.toLowerCase() === planName.toLowerCase();
      })), {}, {
        premium: premium
      })])
    }),
    prevPlanData: _objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().prevPlanData), {}, {
      plans: [].concat(_toConsumableArray(endorseHealthPolicyReadOnlyVar().prevPlanData.plans.filter(function (plan) {
        return plan.name.toLowerCase() !== planName.toLowerCase();
      })), [_objectSpread2(_objectSpread2({}, endorseHealthPolicyReadOnlyVar().prevPlanData.plans.find(function (plan) {
        return plan.name.toLowerCase() === planName.toLowerCase();
      })), {}, {
        premium: premium
      })])
    })
  }));
};
var updateUploadDocsPolicyVar$1 = function updateUploadDocsPolicyVar(documentDetails) {
  uploadDocsPolicyVar$1(_objectSpread2({}, documentDetails));
};

var cache$8 = {
  endorseHealthPolicy: {
    read: function read() {
      return endorseHealthPolicyVar();
    }
  },
  endorseHealthPolicyReadOnly: {
    read: function read() {
      return endorseHealthPolicyReadOnlyVar();
    }
  },
  uploadDocs: {
    read: function read() {
      return uploadDocsPolicyVar$1();
    }
  }
};

var _excluded$1 = ["proposerDetails", "proposerDetailsMeta"],
    _excluded2 = ["proposerDetails", "proposerDetailsMeta"];
var init_state = {
  endorsementEffectiveDate: '',
  endorsementEffectiveTime: '',
  endorsementType: '',
  endorsementTypeValue: '',
  endorsementCategory: '',
  nilEndorsement: false,
  nonNilEndorsement: false,
  businessType: '',
  businessTypeValue: '',
  customerFetchRequiredOnLoad: false,
  productType: '',
  productTypeValue: '',
  isQuoteSaved: false,
  quoteData: null,
  coverData: null,
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  policyNumber: '',
  proposalStatus: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  isExistingEmployee: '',
  isProposalEndorsed: false,
  applicationNo: '',
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: '',
    intermediaryName: '',
    branchOfficeName: ''
  },
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    otherOccupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: true,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: ''
  },
  vehicleTabDetails: {
    vehicleRegistrationDetails: {
      registrationNumber: '',
      registrationNumberParts: {
        part1: '',
        part2: '',
        part3: '',
        part4: ''
      },
      isNewVehicle: false,
      engineNumber: '',
      chasisNumber: ''
    },
    vehicleDetails: {
      make: {
        code: '',
        value: ''
      },
      model: {
        code: '',
        value: ''
      },
      variant: {
        code: '',
        value: ''
      },
      fuelType: '',
      cubeCapacity: '',
      seatingCapacity: '',
      yearOfManufacture: '',
      rtoDetails: {
        rtoAuthorityCode: '',
        rtoLocationCode: '',
        rtoLocationDesc: ''
      },
      dateOfRegistration: '',
      vehicleSegment: '',
      preInspectionNumber: ''
    },
    insuredDeclaredDetails: {
      vehicleIDV: null,
      irfAdjustmentPercent: '',
      idvPct: '',
      irfPct: '',
      sideCarPct: '',
      minChangedIDV: '',
      maxChangedIDV: '',
      sideCarValue: null,
      minSideCarValue: '',
      maxSideCarValue: ''
    }
  },
  additionalTabDetails: {
    previousInsuranceAndClaims: {
      previousPolicyDetails: {
        previousInsurerName: '',
        previousInsurerAddress: '',
        expiringPolicyNumber: '',
        policyCoverType: '',
        policyStartDate: '',
        policyExpiryDate: '',
        policyTenure: '',
        policyTenureValue: ''
      },
      previousClaims: {
        totalClaimCount: '',
        totalClaimCountValue: '',
        totalClaimAmount: '',
        previousYearNCBSlab: '',
        noOfClaimsYear1: '',
        noOfClaimsYear2: '',
        noOfClaimsYear3: ''
      }
    },
    nomineeDetails: {
      NomineeName: '',
      NomineeDOB: '',
      NomineeRelationship: '',
      PAOwnDriverAppointeeName: '',
      PAOwnDriverAppointeeRelation: ''
    },
    financeDetails: {
      vehicleOwned: '',
      financerDetails: {
        financerName: '',
        financerAddress: '',
        financerAgreementType: '',
        loanAccountNumber: '',
        fileNumber: ''
      }
    },
    pucDetails: {
      pucCertificateNo: '',
      pucExpiryDate: ''
    }
  },
  reviewAndConfirmTabDetails: {
    proposalPaymentType: '',
    leadGenerator: '',
    isProposalCreated: false
  },
  otherCoverDetails: {
    isGeoAreaExtension: false,
    isBangladeshCovered: false,
    isBhutanCovered: false,
    isMaldivesCovered: false,
    isNepalCovered: false,
    isPakistanCovered: false,
    isSriLankaCovered: false,
    isVehicleForHandicapped: false,
    isGlassFuelTank: false
  },
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumData: {
    idv1: '',
    idv2: '',
    idv3: '',
    tenure: '',
    netODPremium: null,
    netTPPremium: null,
    loadingDiscount: null,
    netPremium: null,
    gst: null,
    stampDuty: null,
    totalPremium: null,
    loading: [],
    discount: [],
    vehicleAge: '',
    claimFreeYear: '',
    creditScore: ''
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    //CN15
    receiptPayment: {
      receiptId: '' // isReceiptIdVerified: null,

    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var init_state_read_only = {
  endorsementEffectiveDate: '',
  endorsementEffectiveTime: '',
  endorsementType: '',
  endorsementTypeValue: '',
  endorsementCategory: '',
  businessType: '',
  businessTypeValue: '',
  customerFetchRequiredOnLoad: false,
  productType: '',
  productTypeValue: '',
  isQuoteSaved: false,
  quoteData: null,
  coverData: null,
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  policyNumber: '',
  proposalStatus: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  isExistingEmployee: '',
  isProposalEndorsed: false,
  applicationNo: '',
  isProposalRenewing: false,
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: '',
    intermediaryName: '',
    branchOfficeName: ''
  },
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    otherOccupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: true,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: ''
  },
  vehicleTabDetails: {
    vehicleRegistrationDetails: {
      registrationNumber: '',
      registrationNumberParts: {
        part1: '',
        part2: '',
        part3: '',
        part4: ''
      },
      isNewVehicle: false,
      engineNumber: '',
      chasisNumber: ''
    },
    vehicleDetails: {
      make: {
        code: '',
        value: ''
      },
      model: {
        code: '',
        value: ''
      },
      variant: {
        code: '',
        value: ''
      },
      fuelType: '',
      cubeCapacity: '',
      seatingCapacity: '',
      yearOfManufacture: '',
      rtoDetails: {
        rtoAuthorityCode: '',
        rtoLocationCode: '',
        rtoLocationDesc: ''
      },
      dateOfRegistration: '',
      vehicleSegment: '',
      preInspectionNumber: ''
    },
    insuredDeclaredDetails: {
      vehicleIDV: null,
      irfAdjustmentPercent: '',
      idvPct: '',
      irfPct: '',
      sideCarPct: '',
      minChangedIDV: '',
      maxChangedIDV: '',
      sideCarValue: null,
      minSideCarValue: '',
      maxSideCarValue: ''
    }
  },
  additionalTabDetails: {
    previousInsuranceAndClaims: {
      previousPolicyDetails: {
        previousInsurerName: '',
        previousInsurerAddress: '',
        expiringPolicyNumber: '',
        policyCoverType: '',
        policyStartDate: '',
        policyExpiryDate: '',
        policyTenure: '',
        policyTenureValue: ''
      },
      previousClaims: {
        totalClaimCount: '',
        totalClaimCountValue: '',
        totalClaimAmount: '',
        previousYearNCBSlab: '',
        noOfClaimsYear1: '',
        noOfClaimsYear2: '',
        noOfClaimsYear3: ''
      }
    },
    nomineeDetails: {
      NomineeName: '',
      NomineeDOB: '',
      NomineeRelationship: '',
      PAOwnDriverAppointeeName: '',
      PAOwnDriverAppointeeRelation: ''
    },
    financeDetails: {
      vehicleOwned: '',
      financerDetails: {
        financerName: '',
        financerAddress: '',
        financerAgreementType: '',
        loanAccountNumber: '',
        fileNumber: ''
      }
    },
    pucDetails: {
      pucCertificateNo: '',
      pucExpiryDate: ''
    }
  },
  reviewAndConfirmTabDetails: {
    proposalPaymentType: '',
    leadGenerator: '',
    isProposalCreated: false
  },
  otherCoverDetails: {
    isGeoAreaExtension: false,
    isBangladeshCovered: false,
    isBhutanCovered: false,
    isMaldivesCovered: false,
    isNepalCovered: false,
    isPakistanCovered: false,
    isSriLankaCovered: false,
    isVehicleForHandicapped: false,
    isGlassFuelTank: false
  },
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumData: {
    idv1: '',
    idv2: '',
    idv3: '',
    tenure: '',
    netODPremium: null,
    netTPPremium: null,
    loadingDiscount: null,
    netPremium: null,
    gst: null,
    stampDuty: null,
    totalPremium: null,
    loading: [],
    discount: [],
    vehicleAge: '',
    claimFreeYear: '',
    creditScore: ''
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    //CN15
    receiptPayment: {
      receiptId: '' // isReceiptIdVerified: null,

    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var init_state_upload_docs_tw = {
  documentDetails: [{
    documentDescription: '',
    documentName: '',
    documentNameValue: '',
    documentFileName: '',
    documentExtension: '',
    documentSize: null,
    dragging: false,
    dragCounter: 0,
    documentBase64String: ''
  }]
};
var endorseMotorPolicyVar = makeVar(init_state);
var endorseMotorPolicyReadOnlyVar = makeVar(init_state_read_only);
var uploadDocsPolicyVar = makeVar(init_state_upload_docs_tw);
var initEndorseMotorPolicyVar = function initEndorseMotorPolicyVar() {
  endorseMotorPolicyVar(init_state);
  endorseMotorPolicyReadOnlyVar(init_state_read_only);
  uploadDocsPolicyVar(init_state_upload_docs_tw);
};
var updateEndorsementPolicyVar = function updateEndorsementPolicyVar(data) {
  console.log("updateEndorsementPolicyVar data", data);

  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded$1);

  if (proposerDetails && proposerDetailsMeta) {
    endorseMotorPolicyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseMotorPolicyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseMotorPolicyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    endorseMotorPolicyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseMotorPolicyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    endorseMotorPolicyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseMotorPolicyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    endorseMotorPolicyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyVar()), rest));
  }
};
var updateEndorsementPolicyReadOnlyVar = function updateEndorsementPolicyReadOnlyVar(data) {
  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded2);

  if (proposerDetails && proposerDetailsMeta) {
    endorseMotorPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    endorseMotorPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    endorseMotorPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    endorseMotorPolicyReadOnlyVar(_objectSpread2(_objectSpread2({}, endorseMotorPolicyReadOnlyVar()), rest));
  }
};
var updateUploadDocsPolicyVar = function updateUploadDocsPolicyVar(documentDetails) {
  uploadDocsPolicyVar(_objectSpread2({}, documentDetails));
};

var cache$7 = {
  endorseMotorPolicy: {
    read: function read() {
      return endorseMotorPolicyVar();
    }
  },
  endorseMotorPolicyReadOnly: {
    read: function read() {
      return endorseMotorPolicyReadOnlyVar();
    }
  },
  uploadDocsTW: {
    read: function read() {
      return uploadDocsPolicyVar();
    }
  }
};

var cache$6 = mergeCache(cache$8, cache$7);

var cache$5 = mergeCache(cache$9, cache$6);

var userIdVar = makeVar('');
var updateUserId = function updateUserId(data) {
  userIdVar(data);
};

var cache$4 = {
  getUserId: {
    read: function read() {
      return userIdVar();
    }
  }
};

var initialValues = {
  AccountId: '',
  AccountBalance: '',
  AccountExpiry: '',
  intermediaryDetail: {
    intermediaryName: '',
    intermediaryCode: '',
    buisnessLocations: [{
      code: '',
      name: ''
    }]
  }
};
var cdAccountVar = makeVar(initialValues);

var cache$3 = {
  getCdAccount: {
    read: function read() {
      return cdAccountVar();
    }
  }
};

var init_state_business_limits = {
  policyId: '',
  intermediary: {
    code: '',
    value: ''
  },
  policyName: '',
  policyType: '',
  effectiveDate: '',
  // availableProductsForBusinessThroughDigital: [],
  // availableRTOLocations: [],
  // allowedPaymentMethods: [],
  // idvRange: '',
  sumInsuredLimits: [],
  // vehicleAgeLimits: [],
  // availableAddOnCovers: [],
  // selfUnderwritingRight: [],
  standaloneFire: [],
  laghuUdyamSuraksha: [],
  sookshmaUdyamSuraksha: []
};
var createNewBusinessPolicyVar = makeVar(init_state_business_limits);
var updateCreateBusinessLimits = function updateCreateBusinessLimits(data) {
  createNewBusinessPolicyVar(_objectSpread2(_objectSpread2({}, createNewBusinessPolicyVar()), data));
};

var cache$2 = {
  createNewBusinessPolicy: {
    read: function read() {
      return createNewBusinessPolicyVar();
    }
  }
};

var cache$1 = mergeCache(cache$2);

var cache = {
  profileData: {
    read: function read() {
      return profileDataVar();
    }
  }
};

var _excluded = ["component"];
function SecureRoute(_ref) {
  var Component = _ref.component,
      rest = _objectWithoutProperties(_ref, _excluded);

  var fetchQuery = useFetchQuery();

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      fetchIntermediaryFlag = _useState2[0],
      setFetchIntermediaryFlag = _useState2[1];

  var _useQuery = useQuery(CHECK_AUTH_QUERY, {
    fetchPolicy: 'cache-first',
    variables: {
      permission: rest.permission
    },
    onCompleted: function onCompleted(data) {
      var isAuthenticated = data.checkAuth.authenticated;
      var isAuthorized = rest.permission ? data.hasPermission : true;

      if (isAuthenticated && isAuthorized && fetchIntermediaryFlag) {
        var _fetchQuery, _fetchQuery$then;

        (_fetchQuery = fetchQuery({
          query: GET_SELECTED_INTERMEDIARY
        })) === null || _fetchQuery === void 0 ? void 0 : (_fetchQuery$then = _fetchQuery.then(function (response) {
          var _response$data, _response$data$select, _response$data2, _response$data2$selec, _response$data3, _response$data3$selec, _response$data4, _response$data4$selec, _response$data5, _response$data5$selec, _response$data6, _response$data6$selec, _sessionStorage, _sessionStorage2, _sessionStorage3, _sessionStorage4;

          if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$select = _response$data.selectedIntermediary) !== null && _response$data$select !== void 0 && _response$data$select.intermediaryCode) && !(response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && (_response$data2$selec = _response$data2.selectedIntermediary) !== null && _response$data2$selec !== void 0 && _response$data2$selec.intermediaryName) && !(response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && (_response$data3$selec = _response$data3.selectedIntermediary) !== null && _response$data3$selec !== void 0 && _response$data3$selec.branchOfficeCode) && !(response !== null && response !== void 0 && (_response$data4 = response.data) !== null && _response$data4 !== void 0 && (_response$data4$selec = _response$data4.selectedIntermediary) !== null && _response$data4$selec !== void 0 && _response$data4$selec.branchOfficeName) && !(response !== null && response !== void 0 && (_response$data5 = response.data) !== null && _response$data5 !== void 0 && (_response$data5$selec = _response$data5.selectedIntermediary) !== null && _response$data5$selec !== void 0 && _response$data5$selec.fieldUserCode) && !(response !== null && response !== void 0 && (_response$data6 = response.data) !== null && _response$data6 !== void 0 && (_response$data6$selec = _response$data6.selectedIntermediary) !== null && _response$data6$selec !== void 0 && _response$data6$selec.fieldUserName) && (_sessionStorage = sessionStorage) !== null && _sessionStorage !== void 0 && _sessionStorage.getItem('intermediaryCode') && (_sessionStorage2 = sessionStorage) !== null && _sessionStorage2 !== void 0 && _sessionStorage2.getItem('intermediaryName') && (_sessionStorage3 = sessionStorage) !== null && _sessionStorage3 !== void 0 && _sessionStorage3.getItem('branchOfficeCode') && (_sessionStorage4 = sessionStorage) !== null && _sessionStorage4 !== void 0 && _sessionStorage4.getItem('branchOfficeName')) {
            var _sessionStorage5, _sessionStorage5$getI, _sessionStorage6, _sessionStorage6$getI, _sessionStorage7, _sessionStorage7$getI, _sessionStorage8, _sessionStorage8$getI, _sessionStorage9, _sessionStorage9$getI, _sessionStorage10, _sessionStorage10$get;

            setFetchIntermediaryFlag(false);
            updateAllIntermediaryFields({
              intermediaryCode: (_sessionStorage5 = sessionStorage) === null || _sessionStorage5 === void 0 ? void 0 : (_sessionStorage5$getI = _sessionStorage5.getItem('intermediaryCode')) === null || _sessionStorage5$getI === void 0 ? void 0 : _sessionStorage5$getI.toString(),
              intermediaryName: (_sessionStorage6 = sessionStorage) === null || _sessionStorage6 === void 0 ? void 0 : (_sessionStorage6$getI = _sessionStorage6.getItem('intermediaryName')) === null || _sessionStorage6$getI === void 0 ? void 0 : _sessionStorage6$getI.toString(),
              branchOfficeCode: (_sessionStorage7 = sessionStorage) === null || _sessionStorage7 === void 0 ? void 0 : (_sessionStorage7$getI = _sessionStorage7.getItem('branchOfficeCode')) === null || _sessionStorage7$getI === void 0 ? void 0 : _sessionStorage7$getI.toString(),
              branchOfficeName: (_sessionStorage8 = sessionStorage) === null || _sessionStorage8 === void 0 ? void 0 : (_sessionStorage8$getI = _sessionStorage8.getItem('branchOfficeName')) === null || _sessionStorage8$getI === void 0 ? void 0 : _sessionStorage8$getI.toString(),
              fieldUserCode: (_sessionStorage9 = sessionStorage) === null || _sessionStorage9 === void 0 ? void 0 : (_sessionStorage9$getI = _sessionStorage9.getItem('fieldUserCode')) === null || _sessionStorage9$getI === void 0 ? void 0 : _sessionStorage9$getI.toString(),
              fieldUserName: (_sessionStorage10 = sessionStorage) === null || _sessionStorage10 === void 0 ? void 0 : (_sessionStorage10$get = _sessionStorage10.getItem('fieldUserName')) === null || _sessionStorage10$get === void 0 ? void 0 : _sessionStorage10$get.toString()
            });
          }
        })) === null || _fetchQuery$then === void 0 ? void 0 : _fetchQuery$then.catch(function (error) {
          return error;
        });
      } else if (!isAuthenticated && !isAuthorized) {
        var _sessionStorage11, _sessionStorage12, _sessionStorage13, _sessionStorage14, _sessionStorage15, _sessionStorage16;

        updateAllIntermediaryFields({
          intermediaryCode: '',
          intermediaryName: '',
          branchOfficeCode: '',
          branchOfficeName: '',
          fieldUserCode: '',
          fieldUserName: ''
        });
        (_sessionStorage11 = sessionStorage) === null || _sessionStorage11 === void 0 ? void 0 : _sessionStorage11.setItem('intermediaryCode', '');
        (_sessionStorage12 = sessionStorage) === null || _sessionStorage12 === void 0 ? void 0 : _sessionStorage12.setItem('intermediaryName', '');
        (_sessionStorage13 = sessionStorage) === null || _sessionStorage13 === void 0 ? void 0 : _sessionStorage13.setItem('branchOfficeCode', '');
        (_sessionStorage14 = sessionStorage) === null || _sessionStorage14 === void 0 ? void 0 : _sessionStorage14.setItem('branchOfficeName', '');
        (_sessionStorage15 = sessionStorage) === null || _sessionStorage15 === void 0 ? void 0 : _sessionStorage15.setItem('fieldUserCode', '');
        (_sessionStorage16 = sessionStorage) === null || _sessionStorage16 === void 0 ? void 0 : _sessionStorage16.setItem('fieldUserName', '');
      }
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (loading) return /*#__PURE__*/React.createElement(Loading, null);

  if (error) {
    return /*#__PURE__*/React.createElement(Route$f, _extends({}, rest, {
      render: function render(props) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: {
            pathname: '/login'
          }
        });
      }
    }));
  }

  var isAuthenticated = data.checkAuth.authenticated;
  var isAuthorized = rest.permission ? data.hasPermission : true;
  return /*#__PURE__*/React.createElement(Route$f, _extends({}, rest, {
    render: function render(props) {
      return isAuthenticated ? isAuthorized ? /*#__PURE__*/React.createElement(Component, _extends({
        key: props.location.key
      }, props, rest.props)) : /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: '/nopermission'
        }
      }) : /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: '/login'
        }
      });
    }
  }));
}

// Module Specific Routes

var QuantaCache = mergeCache(cache$v, cache$c, cache$5, cache$4, cache$3, cache$1, cache); // Module Routes

var QuantaRoutes = mergeRoutes(Route$3, Route$2, Route$4, Route$8, Route, Route$e, Route$d, Route$b, Route$9, Route$7, Route$6, Route$5, Route$a, Route$1, Route$c); // Secure Route
 // export {default as TransactionComponent} from './lib/security/transaction_component';

export { QuantaCache as Q, SecureRoute as S, updateIpaQuote as a, updateCustomerInformation as b, updateQuotationDetails as c, initCreateIntermediaryState as d, updateEndorsementPolicyVar$1 as e, updatePrevPlanWithPlan as f, updatePlanWithPrevPlan as g, endorseHealthPolicyReadOnlyVar as h, initIpaQuoteState as i, updatePlanPremium as j, updateUploadDocsPolicyVar$1 as k, updateEndorsementPolicyReadOnlyVar$1 as l, updatePlanPremiumReadOnlyVar as m, updateEndorsementPolicyVar as n, updateUploadDocsPolicyVar as o, updateEndorsementPolicyReadOnlyVar as p, initEndorseHealthPolicyVar as q, initEndorseMotorPolicyVar as r, updateUserId as s, updateCreateBusinessLimits as t, updateIntermediary as u, QuantaRoutes as v, mergeCache as w, mergeRoutes as x };
